import React from "react";
import PropTypes from "prop-types";
import { Badge } from "@opendate-app/setlist";
import { formatDate } from "./classLabels";

const STATUSES = {
  draft: { color: "gray", label: "Draft" },
  published: { color: "success", label: "Published" },
  completed: { color: "gray", label: "Completed" },
  canceled: { color: "error", label: "Canceled" },
};

export const classStatusBadge = (status) => STATUSES[status] || { color: "gray", label: String(status || "") };

export default function ClassStatusBadge({ status, size = "sm", opensAt = null, timeZone = null }) {
  if (status === "published" && opensAt) {
    return <Badge color="brand" size={size} dot>{`Opens ${formatDate(opensAt, timeZone)}`}</Badge>;
  }
  const badge = classStatusBadge(status);
  return <Badge color={badge.color} size={size} dot>{badge.label}</Badge>;
}

export const upcomingOpensAt = (classInstance) => (classInstance.registration_opens_later ? classInstance.registration_opens_at : null);

ClassStatusBadge.propTypes = {
  status: PropTypes.string,
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  opensAt: PropTypes.string,
  timeZone: PropTypes.string,
};
